import React from 'react';
import Link from 'gatsby-link';

import config from '../utils/config';
import PageTitle from '../components/PageTitle';

const RSVP = () => (
  <div>
    <PageTitle title="Livestream" />
    {config.live.formHTML}
  </div>
);

export default RSVP;



// WEBPACK FOOTER //
// ./src/pages/live.js